module.exports = __webpack_public_path__ + "media/images/points_bg-132145fbd15930543eb043aea0464cee.png";